import { RelativeTimeTranslations } from './types';

export const defaultTranslations: RelativeTimeTranslations = {
  label: 'Last',
  days: 'Days',
  months: 'Months',
  years: 'Years',
};
